<template>
    <v-sheet>
        <tit-wrap-line noDivider title="결제 정보" />
        <vertical-form-table v-model="form" v-bind="{ items }" mode="view">
            <template slot="결제방법">
                <v-layout align-center>
                    {{ paymentMethod }}
                    <order-view-account :order="value">
                        <template #activator="{ attrs, on }">
                            <v-btn icon text small class="my-n3" v-bind="attrs" v-on="on"> <v-icon small>mdi-information</v-icon> </v-btn>
                        </template>
                    </order-view-account>
                </v-layout>
            </template>
        </vertical-form-table>
    </v-sheet>
</template>

<script>
import { attrs_input, attrs_switch, initOrder, ORDER_TYPES } from "@/assets/variables";

import TitWrapLine from "@/components/client/dumb/tit-wrap-line.vue";
import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";
import OrderViewAccount from "./order-view-account.vue";

const paymentMethods = {
    card: { value: "card", text: "신용카드" },
    kakao: { value: "kakao", text: "카카오페이" },
    account: { value: "account", text: "무통장입금" },
};

export default {
    components: {
        TitWrapLine,
        VerticalFormTable,
        OrderViewAccount,
    },
    props: {
        value: { type: Object, default: initOrder }, // order
    },
    data: () => ({
        form: initOrder(),

        mode: "view",
        loading: false,

        attrs_switch,
    }),
    computed: {
        items() {
            const items = [];

            items.push({ term: "결제금액", type: "currency", key: "totalPrice", suffix: "원" });
            items.push({ term: "결제방법" });
            if (this.form?.pointPrice) items.push({ term: "사용적립금", data: (this.form?.pointPrice?.format?.() || 0) + "원" });

            items.push({ term: "상품금액", data: (this.form?.productPrice?.format?.() || 0) + "원" });
            if (this.form?.canceledProductPrice) items.push({ term: "취소상품금액", data: (this.form?.canceledProductPrice?.format?.() || 0) + "원" });
            if (this.form?.discountPrice) items.push({ term: "할인금액", data: (this.form?.discountPrice?.format?.() || 0) + "원" });
            if (this.form?.canceledDiscountPrice) items.push({ term: "취소할인금액", data: (this.form?.canceledDiscountPrice?.format?.() || 0) + "원" });
            if (this.form.type != ORDER_TYPES.STOCK.value) items.push({ term: "배송비", data: (this.form?.deliveryPrice?.format?.() || 0) + "원" });
            if (this.form?.islandPrice) items.push({ term: "추가배송비(도서산간)", data: (this.form?.islandPrice?.format?.() || 0) + "원" });

            return items.map((item) => ({ ...attrs_input, ...item }));
        },
        paymentMethod() {
            return paymentMethods[this.form?.paymentMethod]?.text || "-";
        },
    },
    mounted() {
        this.init();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        init() {
            this.sync();
            this.mode = "view";
        },
        sync() {
            this.form = initOrder(this.value);
        },
    },
};
</script>

<style></style>
